var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainy7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    slope: 0.05,
    type: "linear"
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rainy-7",
    filter: "url(#blur)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87cefa",
    stroke: "#87cefa",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M47.7,35.4c0-4.6-3.7-8.2-8.2-8.2c-1,0-1.9,0.2-2.8,0.5c-0.3-3.4-3.1-6.2-6.6-6.2c-3.7,0-6.7,3-6.7,6.7c0,0.8,0.2,1.6,0.4,2.3 c-0.3-0.1-0.7-0.1-1-0.1c-3.7,0-6.7,3-6.7,6.7c0,3.6,2.9,6.6,6.5,6.7l17.2,0C44.2,43.3,47.7,39.8,47.7,35.4z",
    transform: "translate(20,10) translate(-20,-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31,46), rotate(10)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 8,
    fill: "none",
    stroke: "#87cefa",
    strokeDasharray: ".1 7",
    strokeLinecap: "round",
    strokeWidth: 3,
    className: "am-weather-rain-1",
    transform: "translate(-5,1)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 8,
    fill: "none",
    stroke: "#87cefa",
    strokeDasharray: ".1 7",
    strokeLinecap: "round",
    strokeWidth: 3,
    className: "am-weather-rain-2",
    transform: "translate(0,-1)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 8,
    fill: "none",
    stroke: "#87cefa",
    strokeDasharray: ".1 7",
    strokeLinecap: "round",
    strokeWidth: 3,
    className: "am-weather-rain-1",
    transform: "translate(5,0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy7);
export default __webpack_public_path__ + "static/media/rainy-7.0bd3e3bdd93d7bfd806f2312ae1a587f.svg";
export { ForwardRef as ReactComponent };